import * as React from 'react';

import classNames from 'classnames';

import {colors} from '../colors/colors';
import {Body} from '../typography/body';

interface Props {
    text: string;
    icon?: React.ComponentType<any>;
    iconSize?: number;
    illustration?: React.ReactNode;
    isHorizontal?: boolean;
    cta?: React.ReactNode;
}

export function CardWidgetEmptyState(props: Props) {
    const {iconSize = 18, isHorizontal = false} = props;
    const Icon = props.icon;

    const containerClassNames = classNames('flex align-center justify-center gap-8 pad-8', {
        'flex-dir-col': !isHorizontal,
    });

    return (
        <div className={containerClassNames}>
            {Icon && (
                <Icon
                    fill={colors.greyXlt}
                    color={colors.greyXlt}
                    size={iconSize}
                    alignCenter={true}
                />
            )}
            {props.illustration}
            <Body color='placeholder' size='small' maintainLineBreaks={true} textAlign='center'>
                {props.text}
            </Body>
            {props.cta}
        </div>
    );
}
